import { useContext } from "react";
import { CIGProfileContext } from "../CIGProfileContext";

const useCigProfileContext = () => useContext(CIGProfileContext);

export default useCigProfileContext;
